/**
 * Determines the type of the player based on the provided version.
 * - Returns "mini" if the version is greater than or equal to the `MINI_PLAYER_VERSION`.
 * - Returns "old" if the version is less than the `MINI_PLAYER_VERSION` or invalid.
 *
 * @param version - The version string to evaluate (e.g., '1.1', '1.0').
 * @returns A string representing the player type: either 'mini' or 'old'.
 */
const MINI_PLAYER_VERSION = 1.1;

export const getPlayerTypeByVersion = (version: string) => {
  const versionAsNum = Number(version || '');
  const isMiniPlayer =
    !Number.isNaN(versionAsNum) && versionAsNum >= MINI_PLAYER_VERSION;
  return isMiniPlayer ? 'mini' : 'old';
};
